import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=249c774a&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('249c774a')) {
      api.createRecord('249c774a', component.options)
    } else {
      api.reload('249c774a', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=249c774a&", function () {
      api.rerender('249c774a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Si36eypDqa1c/JS/comp/IncreaseNumber.vue"
export default component.exports